import { formatearCLP } from '@lexicore/shared';
import { Cargando, ErrorCarga } from '../../componentes/UI';
import { IconoCerrar, IconoImprimir } from '../../componentes/Iconos';
import { usePlanillaPrevired } from '../../lib/consultas';

interface ModalDetallePreviredProps {
  abierto: boolean;
  alCerrar: () => void;
  mes: string;
}

export function ModalDetallePrevired({
  abierto,
  alCerrar,
  mes,
}: ModalDetallePreviredProps) {
  const { data, isLoading, isError, error, refetch } = usePlanillaPrevired(mes);

  if (!abierto) return null;

  const handleImprimir = () => {
    window.print();
  };

  return (
    <div className="modal-overlay" onClick={alCerrar}>
      <div
        className="modal"
        style={{ maxWidth: 640, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 20px',
            borderBottom: '1px solid var(--border-color)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 20 }}>🏛️</span>
            <div>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-primary)' }}>
                Planilla de Leyes Sociales Previred
              </h3>
              <p style={{ margin: '2px 0 0', fontSize: 12, color: 'var(--text-secondary)' }}>
                Período a Declarar: <strong>{mes}</strong>
              </p>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-sm"
            onClick={alCerrar}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--text-secondary)',
              padding: 4,
            }}
            aria-label="Cerrar modal"
          >
            <IconoCerrar size={18} />
          </button>
        </div>

        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 18 }}>
          {isLoading && <Cargando texto="Calculando leyes sociales y cotizaciones…" />}

          {isError && (
            <ErrorCarga
              error={error}
              reintentar={() => void refetch()}
            />
          )}

          {data && (
            <>
              {/* Tarjeta de Cumplimiento Legal Día 13 */}
              <div
                style={{
                  padding: '16px',
                  borderRadius: 8,
                  background:
                    data.estado === 'VENCIDO'
                      ? 'rgba(239, 68, 68, 0.1)'
                      : data.estado === 'POR_VENCER'
                        ? 'rgba(245, 158, 11, 0.1)'
                        : 'rgba(16, 185, 129, 0.1)',
                  border:
                    data.estado === 'VENCIDO'
                      ? '1px solid var(--accent-red, #ef4444)'
                      : data.estado === 'POR_VENCER'
                        ? '1px solid var(--accent-yellow, #f59e0b)'
                        : '1px solid var(--accent-green, #10b981)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 12,
                }}
              >
                <div>
                  <span
                    style={{
                      display: 'inline-block',
                      padding: '2px 8px',
                      fontSize: 10.5,
                      fontWeight: 700,
                      borderRadius: 4,
                      background:
                        data.estado === 'VENCIDO'
                          ? 'var(--accent-red)'
                          : data.estado === 'POR_VENCER'
                            ? 'var(--accent-yellow)'
                            : 'var(--accent-green)',
                      color: '#ffffff',
                      marginBottom: 4,
                    }}
                  >
                    {data.estado === 'VENCIDO'
                      ? '🚨 PLAZO LEGAL VENCIDO'
                      : data.estado === 'POR_VENCER'
                        ? '⚠️ POR VENCER (< 5 DÍAS)'
                        : '✅ DECLARACIÓN AL DÍA'}
                  </span>
                  <div style={{ fontSize: 13, color: 'var(--text-primary)', fontWeight: 600 }}>
                    Fecha Límite Legal Previred: <strong>{data.fechaVencimientoLegal}</strong> (Día 13)
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>
                    {data.diasRestantes > 0
                      ? `Quedan ${data.diasRestantes} días para pagar sin multas ni intereses.`
                      : 'El plazo legal del día 13 ha expirado.'}
                  </div>
                </div>

                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Gran Total Previred</div>
                  <div style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-primary)' }}>
                    {formatearCLP(data.granTotalPrevired)}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>
                    {data.totalTrabajadores} colaboradores cotizantes
                  </div>
                </div>
              </div>

              {/* 4 Tarjetas de Desglose General */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
                  gap: 10,
                }}
              >
                <div style={{ padding: '10px 12px', background: 'var(--bg-card)', borderRadius: 6, border: '1px solid var(--border-color)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>AFP Total</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--accent-blue, #3b82f6)', marginTop: 2 }}>
                    {formatearCLP(data.afpTotal)}
                  </div>
                </div>

                <div style={{ padding: '10px 12px', background: 'var(--bg-card)', borderRadius: 6, border: '1px solid var(--border-color)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Salud (7%)</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--accent-green, #10b981)', marginTop: 2 }}>
                    {formatearCLP(data.saludTotal)}
                  </div>
                </div>

                <div style={{ padding: '10px 12px', background: 'var(--bg-card)', borderRadius: 6, border: '1px solid var(--border-color)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Mutualidad</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', marginTop: 2 }}>
                    {formatearCLP(data.mutualTotal)}
                  </div>
                </div>

                <div style={{ padding: '10px 12px', background: 'var(--bg-card)', borderRadius: 6, border: '1px solid var(--border-color)' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Cesantía (AFC)</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', marginTop: 2 }}>
                    {formatearCLP(data.afcTotal)}
                  </div>
                </div>
              </div>

              {/* Tabla Detallada por Institución */}
              <div>
                <h4 style={{ fontSize: 13, fontWeight: 700, margin: '0 0 8px', color: 'var(--text-primary)' }}>
                  📋 Cuadratura por Institución Previsional
                </h4>
                <div className="tabla-scroll">
                  <table>
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Institución</th>
                        <th style={{ textAlign: 'center' }}>Trabajadores</th>
                        <th style={{ textAlign: 'right' }}>Monto a Declarar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.detallePorInstitucion.map((item, idx) => (
                        <tr key={idx}>
                          <td style={{ fontWeight: 600 }}>
                            <span
                              style={{
                                padding: '2px 6px',
                                fontSize: 10,
                                borderRadius: 3,
                                background: 'var(--bg-muted)',
                                color: 'var(--text-secondary)',
                              }}
                            >
                              {item.tipo}
                            </span>
                          </td>
                          <td style={{ color: 'var(--text-primary)', fontWeight: 500 }}>
                            {item.institucion}
                          </td>
                          <td style={{ textAlign: 'center' }}>{item.trabajadoresCount}</td>
                          <td className="td-mono" style={{ textAlign: 'right', fontWeight: 700 }}>
                            {formatearCLP(item.montoTotal)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Botones de Acción */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: 12,
                  borderTop: '1px solid var(--border-color)',
                }}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleImprimir}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
                >
                  <IconoImprimir size={14} />
                  <span>Imprimir Cuadratura</span>
                </button>

                <button type="button" className="btn btn-primary btn-sm" onClick={alCerrar}>
                  Cerrar
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
